import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { AlertsGrid, CompaniesGrid, UsersGrid } from "../components/admin";
import AllocationsGrid from "../components/admin/AllocationsGrid";
import { ProductConfigurations } from "../components/admin/configurations";
import { Margins } from "../components/admin/margins";
import { useUserContext } from "../hooks/useUserContext";

export const Administration = () => {
  const { context: user } = useUserContext();
  const { permissions } = user;
  const { tab } = useParams();
  const navigate = useNavigate();

  const [selected, setSelected] = useState(0);

  const tabs: string[] = [];
  if (permissions.canAdminCompanies) tabs.push("company");
  if (permissions.canAdminUsers) tabs.push("user");
  if (permissions.canConfigureProducts) tabs.push("product");
  if (permissions.canConfigureMargins) tabs.push("margin");
  tabs.push("allocation");
  if (user.roles.isRiskTaker) tabs.push("alert");

  useEffect(() => {
    if (tab && tabs.indexOf(tab) !== -1) {
      setSelected(tabs.indexOf(tab));
    }
  }, [tab, permissions]);

  return (
    <TabStrip
      selected={selected}
      onSelect={(e) => {
        setSelected(e.selected);
        navigate(`/admin/${tabs[e.selected]}`);
      }}
    >
      {permissions.canAdminCompanies && (
        <TabStripTab title="Companies">
          <CompaniesGrid />
        </TabStripTab>
      )}

      {permissions.canAdminUsers && (
        <TabStripTab title="Users">
          <UsersGrid />
        </TabStripTab>
      )}

      {permissions.canConfigureProducts && (
        <TabStripTab title="Products">
          <ProductConfigurations />
        </TabStripTab>
      )}

      {permissions.canConfigureMargins && (
        <TabStripTab title="Margins">
          <Margins />
        </TabStripTab>
      )}

      <TabStripTab title="Allocations">
        <AllocationsGrid />
      </TabStripTab>

      {user.roles.isRiskTaker && (
        <TabStripTab title="Alerts">
          <AlertsGrid />
        </TabStripTab>
      )}
    </TabStrip>
  );
};
